import React from 'react';
import './Home.css';
import heroImg from './p.jpg';
import fenceImg from './p7.jpg';
import { useNavigate } from 'react-router-dom';

const testimonials = [
  {
    name: "Sarah W.",
    text: "Aaron and his team did an amazing job on our new deck. It completely transformed our backyard. Highly recommended.",
  },
  {
    name: "Mike L.",
    text: "From the first call to the final nail, Classic Fences was professional, on time, and easy to work with. Outstanding quality.",
  },
  {
    name: "Joanne P.",
    text: "We had a custom sliding gate installed and it works perfectly. Aaron made sure everything was done exactly how we wanted.",
  },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">

      {/* Hero */}
      <section className="hero">
        <div className="hero-overlay">
          <img src={heroImg} alt="Classic Fence and Deck craftsmanship" className="hero-bg" />
          <div className="hero-content">
            <p className="hero-tagline">Hamilton's Trusted Fence &amp; Deck Specialists</p>
            <h1>Classic Fence<br />&amp; Deck</h1>
            <p className="hero-sub">Quality craftsmanship. Best price guaranteed. Serving Hamilton and surrounding areas.</p>
            <div className="hero-actions">
              <button className="btn-gold" onClick={() => navigate('/contact')}>Get a Free Estimate</button>
              <button className="btn-outline" onClick={() => navigate('/projects')}>See Our Work</button>
            </div>
          </div>
        </div>
      </section>

      {/* Free Estimate Banner */}
      <section className="estimate-banner">
        <div className="estimate-banner-inner">
          <div className="estimate-banner-text">
            <h2>Free Estimates — No Obligation</h2>
            <p>Call or email Aaron today and get a fast, honest quote on your project.</p>
          </div>
          <div className="estimate-banner-actions">
            <a href="tel:+19059796010" className="btn-navy">📞 Call Aaron</a>
            <a href="mailto:aaronchiarot7@gmail.com" className="btn-navy-outline">✉ Email Aaron</a>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="services-section">
        <h2 className="section-title">What We Build</h2>
        <p className="section-subtitle">Wood, wrought iron, chain link, custom decks, repairs — we do it all.</p>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">🪵</div>
            <h3>Custom Wood Fencing</h3>
            <p>Privacy fences, picket styles, horizontal boards — built to last with premium pressure-treated lumber.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">⚙️</div>
            <h3>Wrought Iron</h3>
            <p>Elegant and durable powder-coated iron fencing and gates that add security without sacrificing style.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🔗</div>
            <h3>Chain Link</h3>
            <p>Affordable, reliable chain link solutions for residential and commercial properties.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🏡</div>
            <h3>Decks &amp; Patios</h3>
            <p>Ground-level or elevated, we design and build decks that become the heart of your outdoor space.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🔧</div>
            <h3>Repairs</h3>
            <p>Leaning posts, rotted panels, broken gates — we fix it right and make it look like new.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🚪</div>
            <h3>Custom Gates</h3>
            <p>Sliding, swinging, or automated — custom gates built to match your fence and fit your driveway.</p>
          </div>
        </div>
      </section>

      {/* Photo Feature */}
      <section className="feature-row">
        <div className="feature-img">
          <img src={fenceImg} alt="Custom horizontal board fence by Classic Fence and Deck" />
        </div>
        <div className="feature-text">
          <h2>Built Right. Built to Last.</h2>
          <p>Every project — from a single gate to a full perimeter fence — gets the same attention to detail. We use quality materials, set proper footings, and finish every job cleanly.</p>
          <p>Aaron has been building fences and decks across Hamilton for years, and the results speak for themselves.</p>
          <button className="btn-gold" onClick={() => navigate('/projects')}>View Our Portfolio</button>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <h2 className="section-title">What Homeowners Are Saying</h2>
        <p className="section-subtitle">Real customers, real results.</p>
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="t-text">"{t.text}"</p>
              <p className="t-name">— {t.name}</p>
            </div>
          ))}
        </div>
        <div className="section-cta">
          <button className="btn-gold" onClick={() => navigate('/reviews')}>Read All Reviews</button>
        </div>
      </section>

    </div>
  );
};

export default Home;
